/**************************************************
 * Nombre:       Formulario_Sectores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, LocalShippingOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {obtenerEstados} from "../../Modulo_EnviosT1/Funciones/obtenerEstados";
import {obtenerProvincia} from "../../Modulo_EnviosT1/Funciones/obtenerProvincia";
import {obtenerCodigoPostal} from "../../Modulo_EnviosT1/Funciones/obtenerCodigoPostal";
import {useEffect, useState} from "react";

const Formulario_Sectores = ({...props}) => {


    useEffect(() => {


        let prov = props.props.getValues('municipio')
        if (prov) {
            props.props.setValue('codigoDestino', obtenerCodigoPostal(prov))
        }


    }, [props.props.watch('municipio'),props.props.watch('estadoMexico')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estadoMexico'} {...props}
                                   opciones={obtenerEstados()}
                                   requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoSelect Icono={Flag} nombre={'Municipio'} dato={'municipio'} {...props}
                                   opciones={obtenerProvincia(props.props.getValues('estadoMexico'))}
                                   requerido={'Campo requerido'}
                    />
                </Grid>



                <Grid container size={6}>
                    <IngresoDinero Icono={LocalShippingOutlined} nombre={'Valor Envio Gratis'}
                                  dato={'valorGratis'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Sectores